import {
  message,
  Message,
  MessageData,
  MessageTypes,
} from 'mostra';

const {
  SnapShot,
} = message;

export {
  SnapShot,
  Message,
  MessageData,
  MessageTypes,
};
export default message;
